import Navbar from "./Navbar";
import {Container} from "react-bootstrap";
import {Outlet, Navigate} from 'react-router-dom'
import {useContext} from "react";
import {AuthContext} from "../../context/AuthContext";
import {ToastContainer} from "react-toastify";

export default function AppLayout() {
    const {isAuthenticated} = useContext(AuthContext)
    return (
        <>
            <Navbar/>
            <Container fluid>
                {isAuthenticated ? <Outlet /> : <Navigate
                    to={{
                        pathname: "/login"
                    }}
                />}
                <ToastContainer theme="dark" position="bottom-right"/>
            </Container>
        </>
    )
}
